import { toast } from 'react-toastify'
import Swal from 'sweetalert2'

export const ShowAlert = {
    ShowConfirm: async () => Swal.fire({
        // title: 'هشدار',
        text: 'آیا برای حذف اطلاعات این صفحه مطمئن هستید؟',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `بله`,
        cancelButtonText: `خیر`,
    }),
    ShowConfirmKala: async () => Swal.fire({
        // title: 'هشدار',
        text: 'آیا قصد حذف کالا/خدمت انتخابی را دارید؟',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `بله`,
        cancelButtonText: `خیر`,
    }),
    ShowConfirmFinal: async (msg) => Swal.fire({
        // title: 'هشدار',
        text: 'آیا قصد ارسال صورتحساب به سامانه ی آزمایشی مودیان را دارید؟ ' + msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `بله`,
        cancelButtonText: `خیر`,
        customClass:'LtfSwal'
    }),
    ShowConfirmAllFinal: async (msg) => Swal.fire({
        // title: 'هشدار',
        html: (`آیا قصد ارسال صورتحساب های انتخابی به سامانه ی ${sessionStorage.getItem('MainOrDemo')} را دارید؟- ` + msg).replaceAll('-', `<br/>`),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `بله`,
        cancelButtonText: `خیر`,
        customClass:'LtfSwal',
        width:'610px'
    }),
    ShowConfirmEstelamAll: async () => Swal.fire({
        // title: 'هشدار',
        text: `آیا قصد استعلام صورتحساب های انتخابی به سامانه ی ${sessionStorage.getItem('MainOrDemo')} را دارید؟ ` ,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `بله`,
        cancelButtonText: `خیر`,
        customClass:'LtfSwal',
        width:'610px'
    }),
    ShowCancelConfirmFinal: async () => Swal.fire({
        // title: 'هشدار',
        text: 'آیا برای لغو ارسال درخواست مطمئن هستید؟',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `بله`,
        cancelButtonText: `خیر`,
    }),
    ShowConfirmWithMsg: async message => Swal.fire({
        // title: 'هشدار',
        //text: 'با حذف رکورد انتخابی کلیه ی اسناد این صورتحساب با شماره سند رکورد انتخابی حذف خواهد شد',
        html: message == '' ? 'ایا از انجام عملیات مطمئن هستید؟' : message.replaceAll('-', '<br/>'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `بله`,
        cancelButtonText: `خیر`,
        width:'610px'
    }),
    ShowConfirmWithMsgWarning: async message => Swal.fire({
        // title: 'هشدار',
        //text: 'با حذف رکورد انتخابی کلیه ی اسناد این صورتحساب با شماره سند رکورد انتخابی حذف خواهد شد',
        html: message == '' ? 'ایا از انجام عملیات مطمئن هستید؟' : message.replaceAll('-', '<br/>'),
        icon: 'error',
        showCancelButton: true,
        confirmButtonText: `بله`,
        cancelButtonText: `خیر`,
        color:'red',
        width:'610px',
    }),
    ShowSuccess: async () => Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'عملیات با موفقیت انجام شد',
        showConfirmButton: false,
        // timer: 2000,
        customClass: 'swial-success'
    }),
    ShowSuccessWithMsg: async message => Swal.fire({
        position: 'center',
        html: message == '' ? 'عملیات با موفقیت انجام شد' : message.replaceAll('-', '<br/>'),
        icon: 'success',
        showConfirmButton: false,
        cancelButtonText: `بستن`,
        customClass: 'swial-success'
    }),
    ShowError: async message => Swal.fire({
        position: 'center',
        html: message == '' ? 'انجام عملیات با مشکل مواجه شده است' : message.replaceAll('-', '<br/>'),
        icon: 'warning',
        // text: message,
        showConfirmButton: false,
        // showCloseButton: true,
        cancelButtonText: `بستن`,
        customClass: 'swial-error',
    }),
    ShowErrorWidth: async message => Swal.fire({
        position: 'center',
        html: message == '' ? 'انجام عملیات با مشکل مواجه شده است' : message.replaceAll('-', '<br/>'),
        icon: 'warning',
        // text: message,
        showConfirmButton: false,
        // showCloseButton: true,
        cancelButtonText: `بستن`,
        customClass: 'swial-error',
        width:800
    }),
    ShowNotChange: async () => Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'هیچ تغییری اعمال نشد',
        showConfirmButton: false,
        timer: 2000,
        customClass: 'swial-success'
    }),
    ToastErrWidth: async message => toast.error(
        message.replaceAll('-','\n'), { autoClose: false, style: {whiteSpace:'pre-line',textAlign:'center',fontFamily:'inherit' ,overflow:'auto'}, className:'toastErr'}
    ),
    ToastSuccess: async message => toast.success(
       message.replaceAll('-', '\n'), { autoClose: 3000, style: { whiteSpace: 'pre-line', textAlign: 'center', fontFamily: 'inherit' } }
    ),
    ToastError: async message => toast.error(
        message.replaceAll('-', '\n'), { autoClose: false, style: { whiteSpace: 'pre-line', textAlign: 'center', fontFamily: 'inherit' } }
     )

}

export const Loading = (close) => {
    // close ? Swal.fire({ title: 'پیغام', text: 'لطفا کمی منتظر بمانید...', showConfirmButton: false, customClass: 'swial-success' }) : Swal.fire({ title: '', text: '', timer: AutoComplete })
    Swal.fire({ title: 'پیغام', text: 'لطفا کمی منتظر بمانید...', showConfirmButton: false, customClass: 'swial-success' })
}